import { IMAGE_DIMENSIONS } from '@/components/Image/Image'

export const ORIENTATIONS = {
  vertical: 'vertical',
  horizontal: 'horizontal'
}

export const SHAPES = {
  circle: 'circle',
  rectangle: 'rectangle'
}

/**
 * data class for a simple element
 * @param {Object} elementData the data retrieved from the backend
 * @param {Object} options configurable fields in the channel {shape, orientation}
 */
export default class Simple {
  constructor (elementData, options = {}) {
    this.id = elementData.id
    this.type = 'hp-simple'
    this.text = elementData.headline
    this.shape = options.shape || SHAPES.circle
    this.orientation = options.orientation || ORIENTATIONS.vertical
    this.backgroundColor = ''
    this.icon = elementData.icon || null
    this.figure = elementData.image?.url
      ? {
        img: {
          url: elementData.image?.url,
          isCoreMedia: elementData.image?.coreMediaImage,
          alt: elementData.image?.altText || null,
          lazy: elementData.image?.lazyLoading ?? true,
          width: options.width ?? IMAGE_DIMENSIONS.simple.width,
          height: options.height ?? IMAGE_DIMENSIONS.simple.height
        }
      }
      : null

    this.link = elementData.link
      ? {
        href: elementData.link.url || null,
        target: elementData.link.external ? '_blank' : null,
        rel: elementData.link.behaviour || null
      }
      : null
  }
}
